import { VF_TEXTAREA } from 'AppSrc/core/components/forms/form-base-components/v-f-textarea';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';

const fieldId = 'customer_impact_statement';

const initialValues = '';

const minCharacters = 20;

const vFParams = {
  fieldTitle: 'Customer Impact Statement',
  fieldSubTitle: 'Please note: this will be displayed to customers as part of the change comms.',
  characterLimit: 3000, // don't forget to add to validator
  placeholder: 'Enter text',
};

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_TEXTAREA);
  const overCharacterLimit = commonValidation.textInput.isOverCharacterLimit(values[fieldId], vFParams.characterLimit);
  const underCharacterMin = commonValidation.textInput.isUnderCharacterMinimum(values[fieldId], minCharacters);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please provide impact statement' : null);
  errors[INLINE_ERRORS].push((overCharacterLimit) ? 'Text exceeds character limit' : null);
  errors[INLINE_ERRORS].push((underCharacterMin && !noValue) ? 'Text has too few characters' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

const customerImpactStatement = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_TEXTAREA,
};

export { customerImpactStatement };
